// -----------------------------------------------------------------------------
// Check if is a touch device
// -----------------------------------------------------------------------------
window.isTouchDevice = function() {
  return 'ontouchstart' in document.documentElement;
}

if (isTouchDevice()) {
  document.body.classList.add('touch');
} else {
  document.body.classList.add('no-touch');
}



// WEBPACK FOOTER //
// ./scripts/util/checkTouch.js